import React from "react";
import VendorConfigContainer from "../../containers/VendorDetails/ConfigDetail";

const VendorConfig = (props) => {
  return (
    <>
      <VendorConfigContainer {...props} />
    </>
  );
};

export default VendorConfig;